// @flow

import React from 'react'

import { UnstyledList } from '../../components/typography'
import {
  PostTitle,
  PostGroup,
  PostLink,
} from '../../scenes/feed'

import { worksData } from '../../data/api'

const WorksIndex = () => (
  <PostGroup>
    <PostTitle>Works</PostTitle>
    <UnstyledList>
      {worksData
        .map(item =>
          item.published && (
            <PostLink
              key={item.id}
              title={item.title}
              date={item.initialPostDate}
              to={item.url}
            />
      ))}
    </UnstyledList>
  </PostGroup>
)

export default WorksIndex



// WEBPACK FOOTER //
// ./src/pages/works/index.js